// extracted by css-extract-rspack-plugin
export default {"taskContainer":"CandidateTasks_taskContainer__V47Tl","deadline":"CandidateTasks_deadline__wB+By","taskWrapper":"CandidateTasks_taskWrapper__iySNp"};